
import { Layout } from 'antd';

const { Footer } = Layout;

const footerStyle: React.CSSProperties = {
    textAlign: 'left',
    color: '#fff',
    paddingLeft:300,
    backgroundColor: '#123758',
  };

export default function Fottertag() {
    return(
        <Footer style={footerStyle}>사업자등록번호: 575-88-02193, 정보통신업, 서울시 종로구 대학로 103, 서울대학교의과대학 의과학관 227호 
        <br/>
         © Copyright AvChain, inc. All Rights Reserved</Footer>
    );
}